import React from "react";
import { BookOpenIcon, GiftIcon, CheckIcon, GlobeIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { images } from "../data/content";
const perks = ["One-time payment", "Lifetime access", "No monthly fees", "Instant digital access"];
export function Offer() {
  return <section id="offer" className="px-3 py-16 md:px-5 md:py-24" data-id="element-194" data-mp="tylb5bj25km8">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-[28px] bg-plum-900 text-white shadow-2xl shadow-plum-900/30" data-id="element-195" data-mp="u0xt3ootfuza">
        <div className="bg-gold px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wide text-plum-950" data-id="element-196" data-mp="13wrelxkiiyt7">
          Special launch offer
        </div>
        <div className="px-5 pb-10 pt-8 md:px-10" data-id="element-197" data-mp="ywmxc5bs601x">
          <h2 className="text-center font-display text-[28px] font-extrabold leading-tight md:text-4xl" data-id="element-198" data-mp="2fboek2i8j8fc">
            Here's everything you'll get today
          </h2>

          <img src={images.mockup} alt="Complete Implant Decision System bundle" className="mx-auto mt-6 w-full rounded-2xl bg-white" data-id="element-199" data-mp="2affss69j8gz7" />

          <ul className="mt-6 divide-y divide-white/10 rounded-2xl bg-white/5" data-id="element-200" data-mp="uiio7s08gnpk">
            <li className="flex items-center gap-3 p-4" data-id="element-201" data-mp="ziobyx3dtq2d">
              <BookOpenIcon className="h-6 w-6 shrink-0 text-gold" aria-hidden data-id="element-202" data-mp="zj6cw70zosgm" />
              <div className="flex-1" data-id="element-203" data-mp="13ip23ezufpp9">
                <p className="font-bold" data-id="element-204" data-mp="13hnkerobo4yk">Implant Decision System™</p>
                <p className="text-sm text-plum-100" data-id="element-205" data-mp="6vahr6r2j8ly">6 premium volumes</p>
              </div>
              <s className="text-plum-200" data-id="element-206" data-mp="btc2dw457fzj">$97</s>
            </li>
            <li className="flex items-center gap-3 p-4" data-id="element-207" data-mp="ftw319nxd1qf">
              <GiftIcon className="h-6 w-6 shrink-0 text-gold" aria-hidden data-id="element-208" data-mp="fsb7phtsderi" />
              <div className="flex-1" data-id="element-209" data-mp="kmp3hlcd1nwp">
                <p className="font-bold" data-id="element-210" data-mp="3k8m0kt4ww121">5 Professional Bonuses</p>
                <p className="text-sm text-plum-100" data-id="element-211" data-mp="3k8doh3gm4zrw">Cases, red flags, scorecard, checklist, cards</p>
              </div>
              <s className="text-plum-200" data-id="element-212" data-mp="3o7uv407s02yn">$147</s>
            </li>
          </ul>

          <div className="mt-8 text-center" data-id="element-213" data-mp="vdnwwp85g39r">
            <p className="text-sm font-bold uppercase tracking-wider text-plum-200" data-id="element-214" data-mp="qh5wu2nrkt3r">
              Total value: <s className="text-red-400" data-id="element-215" data-mp="1561ztlayrfxi">$244</s>
            </p>
            <p className="mt-2 text-[17px] text-plum-100" data-id="element-216" data-mp="157d5jqnyyxr9">Today, you can get everything for just…</p>
            <p className="mt-1 font-display text-[88px] font-black leading-none text-white md:text-[112px]" data-id="element-217" data-mp="108ti1ltq9dws">
              <span className="align-top text-4xl md:text-5xl" data-id="element-218" data-mp="7hrzdaqtt08i">$</span>27
            </p>
            <p className="mt-1 text-sm font-semibold text-plum-100" data-id="element-219" data-mp="7k4pwcangix6">USD · one-time payment</p>
          </div>

          <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-220" data-mp="hfzcfihzuy58">
            {perks.map(p => <li key={p} className="flex items-center gap-2 text-[15px] font-medium" data-id="element-221" data-mp="1ww6rm511z58r">
                <CheckIcon className="h-4 w-4 shrink-0 text-green-400" strokeWidth={3} aria-hidden data-id="element-222" data-mp="1svehzao9qyby" />
                {p}
              </li>)}
          </ul>

          <p className="mx-auto mt-6 flex max-w-md items-start justify-center gap-2 rounded-xl bg-white/10 px-4 py-3 text-center text-sm text-white" data-id="element-223" data-mp="20gqixsdksy7u">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden data-id="element-224" data-mp="1qh9flhlsqwf1" />
            Currency conversion is automatic — you'll see the price in your local currency at checkout.
          </p>

          <div className="mt-7" data-id="element-225" data-mp="2j4visor43z1d">
            <ScarcityBar data-id="element-226" data-mp="2j5x2tiq3vvv8" />
          </div>

          <div className="mt-7" data-id="element-227" data-mp="2o3ylw3nj7v6p">
            <CtaButton tone="dark" label="Get my Implant Decision System™" sub="One-time payment of $27 · Instant access · 7-Day Guarantee" data-id="element-228" data-mp="2o2wyr0t8ri8m" />
          </div>

          <div className="mt-8" data-id="element-229" data-mp="2ecu8v9hf2kei">
            <Countdown tone="dark" data-id="element-230" data-mp="323zmrj3sr2m6" />
          </div>
        </div>
      </div>
    </section>;
}